module.exports = __webpack_public_path__ + "img/2-4.b144c0d3.svg";